// Backend builds names like "Botswana -1.0GB 2dni"; the unit differs per language (GB, Go, ГБ...)
const UNLIMITED_IN_NAME = /(^|\s)-1(?:[.,]0+)?\s?[^\s\d,.\-]{1,3}/g;

export const formatPackageName = (name, unlimitedLabel) =>
  typeof name === "string" ? name.replace(UNLIMITED_IN_NAME, `$1${unlimitedLabel}`) : name;
